/** Configurazione runtime scritta da CDK in /config.json (in locale: scripts/dev.sh, sempre prod). */
export interface AdminConfig {
  env: string;
  apiUrl: string;
  region: string;
  userPoolId: string;
  clientId: string;
  siteUrl: string;
  /** origine delle immagini (/media/…), se diversa dal sito */
  mediaUrl?: string;
  release: string | null;
}

export async function loadConfig(): Promise<AdminConfig> {
  // in locale scripts/dev.sh usa /config.prod.json (il config.json di prod con il sito in locale)
  const res = await fetch(import.meta.env.VITE_CONFIG ?? '/config.json', { cache: 'no-store' });
  if (!res.ok) throw new Error(`config.json non disponibile (${res.status})`);
  return (await res.json()) as AdminConfig;
}
